/**
 * Backend signals "authenticated but not entitled" (e.g. EnsurePremium middleware).
 * Must not be treated as a broken or expired session.
 */
export function isPremiumRequiredError (error) {
  return Boolean(
    error?.response?.status === 403 &&
    error?.response?.data?.error === 'premium_required'
  )
}

/**
 * Whether to clear token and user (session) for this failed response.
 * 401 = unauthenticated. 403 = only when it is not a known "still logged in" case.
 */
export function shouldClearSessionOnHttpError (error) {
  const status = error?.response?.status
  if (status === 401) {
    return true
  }
  if (status === 403 && !isPremiumRequiredError(error)) {
    return true
  }
  return false
}
